import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { useCartStore } from '@entities/Cart'

import { useModalStore } from '@features/modal'
import usePaymentVerificator from '@features/payment/hooks/usePaymentVerificator'
import VerifierModal from '@features/payment/ui/verifier-modal/VeriferModal'

type Props = {
  onFinish?: () => void;
  isOrder?: boolean;
};

export const PaymentVerifier = ({ onFinish, isOrder }: Props) => {
  const [ searchParams, setSearchParams ] = useSearchParams()
  const operationId = searchParams.get('operationId')

  const { verified, rejected, isLoading } = usePaymentVerificator({
    operationId: operationId ?? '',
  })

  useEffect(() => {
    if (!isLoading && (verified || rejected)) {
      onFinish?.()
      setSearchParams({})
    }
  }, [ isLoading, verified, rejected, onFinish, setSearchParams ])

  const { clearCart } = useCartStore()
  const { openModal } = useModalStore()

  useEffect(() => {
    if (verified) {
      if (isOrder) {
        clearCart()
      }
      else {
        openModal('verifierPayment', <VerifierModal success />)
      }
    }
    else if (rejected && !isOrder) {
      openModal('verifierPayment', <VerifierModal />)
    }
  }, [ isLoading, verified, rejected, isOrder, openModal ])

  useEffect(() => {
    if (!isLoading && (verified || rejected)) {
      onFinish?.()
      setSearchParams({})
    }
  }, [ isLoading, verified, rejected, onFinish, setSearchParams ])

  if (!operationId) return null
}
